import React from 'react';

export default function CheckboxIcon({ className }) {
	return (
		<svg 
			className={className}
			width="32"
			height="32"
			viewBox="0 0 32 32"
			fill="none"
			xmlns="http://www.w3.org/2000/svg">
			<rect x="4.5"
				y="4.5"
				width="23"
				height="23"
				rx="3.5"
				stroke="#C0C0C0"/>
		</svg>

	);
}

